import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { watch, ref } from 'vue';
import { VxeSelect } from 'vxe-pc-ui';
import { useAuthorStore } from '@/stores';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'mg-u-dict-select',
  props: {
    cate: {
      type: String,
      default: ''
    },
    // 字典名称(cate)
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    isViewMode: {
      type: Boolean,
      default: false
    },
    // 表单预览模式
    isEditMode: {
      type: Boolean,
      default: false
    },
    // 表单设计器预览模式
    accessToken: {
      type: String,
      default: ''
    } // 获取数据的令牌
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const authorStore = useAuthorStore();
    const selectCate = ref('');
    const list = ref([]);
    const {
      loading,
      runAsync: getDictionaryListApi
    } = fetchApi('common.uDictionary.getList');
    const loadDictionaryList = async cate => {
      if (cate === '') {
        selectCate.value = '';
        list.value = [];
        return Promise.resolve(false);
      }
      if (!authorStore.token && !props.accessToken) {
        return false;
      }
      const queryParams = {
        cate
      };
      if (props.accessToken) {
        queryParams.accessToken = props.accessToken;
      }
      const {
        error,
        rows
      } = await getDictionaryListApi(queryParams);
      if (error) return;
      selectCate.value = cate;
      list.value = rows.map(item => {
        const {
          value,
          title,
          status
        } = item;
        return {
          value,
          label: title,
          disabled: status === 1
        };
      });
      return Promise.resolve(rows);
    };
    watch(() => [props.isEditMode, props.cate], attr => {
      const [isEditMode, cate] = attr;
      if (!isEditMode && cate) {
        loadDictionaryList(cate);
      }
    }, {
      immediate: true
    });
    const refresh = async () => {
      return loadDictionaryList(selectCate.value);
    };
    __expose({
      refresh
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(VxeSelect), _mergeProps({
        loading: _unref(loading),
        options: list.value,
        disabled: __props.disabled,
        readonly: __props.readonly,
        clearable: __props.clearable,
        filterable: __props.filterable
      }, _ctx.$attrs), null, 16, ["loading", "options", "disabled", "readonly", "clearable", "filterable"]);
    };
  }
};